import React from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/components/trans';
import {PopoverCoordinator} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {ModifiersEnum} from '../../../../../../srcCommon/inboxes/search/searchModifiersHelpers';
import {TagModel} from '../../../../../models/api/tagModel';
import {renderTagIcon} from '../../../../common/dropdowns/dropdownItemTagIcon';
import {trackSearchHintDropdownOpen} from '../../searchTrackingHelpers';
import {maybeTruncateString} from '../searchHintItem';
import {SearchHintItemPill, SearchHintItemPillTitle} from '../searchHintItemPill';
import {SearchHintTagDropdown} from './searchHintTagDropdown';

/*
 * Props.
 */

interface SearchHintTagItemProps {
  isDisabled: boolean;
  selectedTags: ReadonlyArray<TagModel>;
  queryHash: string | undefined;
  onSelectedTagsChange: (selectedTags: ReadonlyArray<TagModel>) => void;
}

/*
 * Component.
 */

export const SearchHintTagItem = (props: SearchHintTagItemProps) => {
  const {isDisabled, selectedTags, queryHash, onSelectedTagsChange} = props;
  const interactionId = `search-hint-tag`;
  const isActive = selectedTags.length > 0;

  return (
    <PopoverCoordinator
      renderButton={(isOpen) => (
        <SearchHintItemPill
          isActive={isActive}
          isDisabled={isDisabled}
          isHovered={isOpen}
          interactionId={interactionId}
        >
          {renderTagsPillTitle(selectedTags)}
        </SearchHintItemPill>
      )}
      renderModal={(popoverProps) => (
        <SearchHintTagDropdown
          popoverProps={popoverProps}
          selectedTags={selectedTags}
          onSelectedTagsChange={onSelectedTagsChange}
        />
      )}
      onPopoverToggle={(isOpen) => {
        if (isOpen) {
          trackSearchHintDropdownOpen({
            queryHash,
            modifier: ModifiersEnum.TAG,
          });
        }
      }}
    />
  );
};

export function renderTagsPillTitle(selectedTags: ReadonlyArray<TagModel>) {
  if (selectedTags.length === 0) {
    return <Trans id="search-hint-tag">Tag</Trans>;
  }

  const TRUNCATION_LIMIT = 21;
  const truncatedTagName = maybeTruncateString(selectedTags[0].name, TRUNCATION_LIMIT);
  const firstTagIcon = renderTagIcon(selectedTags[0]);

  if (selectedTags.length === 1) {
    return <SearchHintItemPillTitle icon={firstTagIcon} title={truncatedTagName} />;
  }

  // Else, selectedTags.length > 1.
  return (
    <SearchHintItemPillTitle icon={firstTagIcon} title={`${truncatedTagName}, +${selectedTags.length - 1}`} />
  );
}
